module.exports = {"domain":"https://ikotema.digital","locales":[{"code":"pt","name":"Brazilian Portuguese"},{"code":"en","name":"English"}]}


//////////////////
// WEBPACK FOOTER
// ./data/config.yaml
// module id = laZd
// module chunks = 0